<template>
  <VModal
    ref="modal"
    modal-classes="max-w-md mx-auto"
    disable-backdrop-click
    @modal:hidden="$emit('closed')"
  >
    <div class="rounded shadow-xs w-full max-w-lg mx-auto" @click.stop>
      <div class="rounded shadow-lg bg-white overflow-hidden divide-y divide-gray-200">
        <div class="h-10 bg-white pl-4">
          <div class="flex items-center justify-between">
            <div class="flex-1">
              <h1 class="text-sm">Update Asset Tags</h1>
            </div>
            <div class="flex-none">
              <button
                class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                @click="$refs.modal.close()"
              >
                <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                  <path
                    d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                    4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                    4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                    5.636z"
                  />
                </svg>
              </button>
            </div>
          </div>
        </div>
        <BaseVeeForm :action="trySubmit" v-slot="{ isPending, invalid }">
          <div v-if="!loading" class="p-10 space-y-6">
            <p class="text-gray-600 text-sm">
              Choose the tags that you wish to apply to your assets. Selected tags will replace any
              existing tags.
            </p>
            <ValidationProvider name="tags" slim vid="tags">
              <template #default="{ errors }">
                <BaseFormGroup>
                  <BaseFormLabel for="tags"> Tags </BaseFormLabel>
                  <ul class="flex flex-wrap -mx-1">
                    <template v-for="tag in tags">
                      <li :key="tag.id" class="p-1">
                        <label
                          class="inline-flex p-1 border border-transparent text-sm rounded-full focus-within:ring ring-blue-500 ring-opacity-50 focus-within:border-blue-700"
                          :class="[
                            formData.tags.indexOf(tag.id) > -1
                              ? 'bg-blue-600 text-white'
                              : 'bg-gray-200',
                          ]"
                        >
                          <input
                            v-model="formData.tags"
                            type="checkbox"
                            :value="tag.id"
                            class="appearance-none opacity-0"
                          />
                          <div class="flex items-center px-2 space-x-2">
                            <span class="inline-flex leading-4">
                              {{ tag.name }}
                            </span>
                          </div>
                        </label>
                      </li>
                    </template>
                  </ul>
                  <BaseFormInlineMessage v-if="errors.length" danger>
                    {{ errors[0] }}
                  </BaseFormInlineMessage>
                </BaseFormGroup>
              </template>
            </ValidationProvider>
          </div>
          <div class="flex space-x-2 p-10">
            <BaseButton primary :disabled="isPending || invalid"> Update Asset Tags </BaseButton>
            <BaseButton
              type="button"
              ghost
              :disabled="isPending || invalid"
              @click="$refs.modal.close()"
            >
              Maybe later
            </BaseButton>
          </div>
        </BaseVeeForm>
      </div>
    </div>
  </VModal>
</template>

<script>
import { accountAssetTagsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
    assetIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      tags: [],
      formData: {
        tags: [],
      },
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      try {
        this.loading = true;
        await this.tryFetchAccountAssetTagList();
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
    async tryFetchAccountAssetTagList() {
      try {
        const response = await accountAssetTagsClient.list(this.accountId);

        this.tags = response?.data?.data || [];
      } catch (error) {
        //
      }
    },
    async trySubmit() {
      try {
        await this.$store.dispatch({
          type: 'ui/accountAssets/update',
          accountId: this.accountId,
          formData: {
            assets: this.assetIds.map((id) => ({
              id,
              tags: this.formData.tags,
            })),
          },
        });
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
